import React from 'react';
import { array, func, string } from 'prop-types';
import useStyles from 'hooks/useStyles';

import BaseSwiper from 'components/BaseSwiper';
import {
  TABLET_WIDTH,
  DESKTOP_WIDTH,
  WIDE_DESKTOP_WIDTH,
} from 'styles/variables.scss';

import styles from './CourseSwiper.scss';

const CourseSwiper = ({
  id,
  handleGetSwiperRef,
  slideDataList,
  renderSlide,
}) => {
  useStyles(styles);

  const breakpoints = {
    [WIDE_DESKTOP_WIDTH]: {
      slidesPerView: 4,
      slidesPerGroup: 1,
    },
    [DESKTOP_WIDTH]: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
    [TABLET_WIDTH]: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    0: {
      slidesPerView: 1.2,
      slidesPerGroup: 1,
    },
  };

  const onSwiper = ref => {
    if (ref) {
      handleGetSwiperRef(ref);
    }
  };

  return (
    <BaseSwiper
      id={id}
      onSwiper={onSwiper}
      classNameMap={{
        root: styles.root,
      }}
      slideDataList={slideDataList}
      renderSlide={renderSlide}
      breakpoints={breakpoints}
      pagination
      navigation
    />
  );
};

CourseSwiper.defaultProps = {
  handleGetSwiperRef: () => {},
};

CourseSwiper.propTypes = {
  id: string.isRequired,
  slideDataList: array.isRequired,
  renderSlide: func.isRequired,
  handleGetSwiperRef: func,
};

export default CourseSwiper;
